class RevealOnScroll extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
  }

  connectedCallback() {
    this.revealWrapper = this.querySelector('.reveal-content');
    this.slides = Array.from(this.querySelectorAll('.reveal-content__content'));
    this.contentTotal = this.slides.length;
    this.revealWrapperHeight = this.contentTotal * 100;
    this.revealWrapper.style.setProperty('--reveal-wrapper-height', `${this.revealWrapperHeight}svh`);

    window.addEventListener('scroll', this.handleScroll);
    this.addEventListener('focusin', this.handleFocusIn);
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    this.removeEventListener('focusin', this.handleFocusIn);
  }

  getRevealWrapperTop() {
    return this.revealWrapper.getBoundingClientRect().top + window.scrollY;
  }

  getScrollYFromClipAmount(clipAmount) {
    return clipAmount / this.revealWrapperHeight * this.revealWrapper.offsetHeight;
  }

  updateSlideAccessibility(clipAmount) {
    if (!this.slides.length) return;

    const activeSlideIndex = Math.min(Math.floor(clipAmount / 100), this.slides.length - 1);
    this.slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index === activeSlideIndex ? 'false' : 'true');
    });
  }

  handleFocusIn(event) {
    const slide = event.target.closest('.reveal-content__content');
    if (!slide || !this.contains(slide)) return;

    const slideIndex = this.slides.indexOf(slide);
    if (slideIndex === -1) return;

    const clipAmount = slideIndex * 100;

    const targetY = this.getRevealWrapperTop() + this.getScrollYFromClipAmount(clipAmount);
    if (Math.abs(window.scrollY - targetY) > 1) {
      window.scrollTo({ top: targetY, behavior: 'auto' });
      this.handleScroll();
    }
  }

  handleScroll() {
    const revealWrapperTop = this.getRevealWrapperTop();
    const scrollY = Math.max(window.scrollY - revealWrapperTop, 0);
    const sectionHeight = this.revealWrapper.offsetHeight;
    const clipAmount = Math.min(scrollY / sectionHeight * this.revealWrapperHeight, 200);

    /* MIDDLE DIV */
    const middleDiv = this.querySelector('.reveal-content__content.middle');
    if (middleDiv) {
      const topSecondItemClip = Math.max(100 - clipAmount, 0);
      middleDiv.style.setProperty('--clipInsetTopSecondItem', `${topSecondItemClip}svh`);

      if (topSecondItemClip === 0 && clipAmount <= 200) {
        const bottomClipAmount = -30 + ((clipAmount - 100) / 100 * 130);
        middleDiv.style.setProperty('--clipInsetBottomSecondItem', `${bottomClipAmount}svh`);
      }
    }

    /* LAST DIV */
    const lastDiv = this.querySelector('.reveal-content__content.last');
    if (lastDiv) {
      const lastClipAmount = Math.max(100 - clipAmount, 0);
      lastDiv.style.setProperty('--clipInsetLastItem', `${lastClipAmount}svh`);
    }

    this.updateSlideAccessibility(clipAmount);
  }
}

customElements.define('reveal-on-scroll', RevealOnScroll);
